<template>
  <v-layout row wrap style="flex: 1 0; overflow: auto; align-items: center; justify-content: center">
    <v-flex v-if="userSecurity[SecurityItemsKeys.ADMIN_GLIDER].enable" xs6 sm4 md3 lg2 class="inline-block pa-4">
      <v-card class="pa-2" :to="{ name: 'NewGlider' }" exact>
        <v-img contain :src="require('@/assets/glider.jpg')" height="100"></v-img>
        <v-card-title>{{ $t('Admin.Glider.MenuTitle') }}</v-card-title>
      </v-card>
    </v-flex>
    <v-flex v-if="userSecurity[SecurityItemsKeys.ADMIN_COMPANY].enable" xs6 sm4 md3 lg2 class="inline-block pa-4">
      <v-card class="pa-2" :to="{ name: 'NewEnseigne' }" exact>
        <v-img contain :src="require('@/assets/company-building-icon.png')" height="100"></v-img>
        <v-card-title>{{ $t('Admin.Enseigne.MenuTitle') }}</v-card-title>
      </v-card>
    </v-flex>
    <v-flex
      v-if="userSecurity[SecurityItemsKeys.ADMIN_MOBIL_UNIT_CLASS].enable"
      xs6
      sm4
      md3
      lg2
      class="inline-block pa-4"
    >
      <v-card class="pa-2" :to="{ name: 'NewUmbClasse' }" exact>
        <v-img contain :src="require('@/assets/sea-explorer-interchangeable-payloads.png')" height="100"></v-img>
        <v-card-title>{{ $t('Admin.UmbClasse.MenuTitle') }}</v-card-title>
      </v-card>
    </v-flex>
    <v-flex
      v-if="userSecurity[SecurityItemsKeys.ADMIN_MOBIL_UNIT_TYPE].enable"
      xs6
      sm4
      md3
      lg2
      class="inline-block pa-4"
    >
      <v-card class="pa-2" :to="{ name: 'NewUmbType' }" exact>
        <v-img contain :src="require('@/assets/sea-explorer-interchangeable-payloads.png')" height="100"></v-img>
        <v-card-title>{{ $t('Admin.UmbType.MenuTitle') }}</v-card-title>
      </v-card>
    </v-flex>
    <v-flex v-if="userSecurity[SecurityItemsKeys.ADMIN_MOBIL_UNIT].enable" xs6 sm4 md3 lg2 class="inline-block pa-4">
      <v-card class="pa-2" :to="{ name: 'NewUniteMobile' }" exact>
        <v-img contain :src="require('@/assets/sea-explorer-interchangeable-payloads.png')" height="100"></v-img>
        <v-card-title>{{ $t('Admin.UniteMobile.MenuTitle') }}</v-card-title>
      </v-card>
    </v-flex>
    <v-flex v-if="userSecurity[SecurityItemsKeys.ADMIN_USER].enable" xs6 sm4 md3 lg2 class="inline-block pa-4">
      <v-card style="text-align: center" class="pa-2" :to="{ name: 'NewUser' }" exact>
        <v-icon color="#444" size="100">mdi-account-circle</v-icon>
        <v-card-title>{{ $t('Admin.User.MenuTitle') }}</v-card-title>
      </v-card>
    </v-flex>
    <v-flex v-if="userSecurity[SecurityItemsKeys.ADMIN_ROLE].enable" xs6 sm4 md3 lg2 class="inline-block pa-4">
      <v-card style="text-align: center" class="pa-2" :to="{ name: 'NewRole' }" exact>
        <v-icon color="#444" size="100">mdi-account-key</v-icon>
        <v-card-title>{{ $t('Admin.Role.MenuTitle') }}</v-card-title>
      </v-card>
    </v-flex>
    <v-flex v-if="userSecurity[SecurityItemsKeys.ADMIN_MESURETYPE].enable" xs6 sm4 md3 lg2 class="inline-block pa-4">
      <v-card style="text-align: center" class="pa-2" :to="{ name: 'NewMesureType' }" exact>
        <v-icon color="#444" size="100">mdi-leak</v-icon>
        <v-card-title>{{ $t('Admin.MesureType.MenuTitle') }}</v-card-title>
      </v-card>
    </v-flex>
    <v-flex v-if="userSecurity[SecurityItemsKeys.ADMIN_MESUREUNIT].enable" xs6 sm4 md3 lg2 class="inline-block pa-4">
      <v-card style="text-align: center" class="pa-2" :to="{ name: 'NewMesureUnite' }" exact>
        <v-icon color="#444" size="100">mdi-antenna</v-icon>
        <v-card-title>{{ $t('Admin.MesureUnite.MenuTitle') }}</v-card-title>
      </v-card>
    </v-flex>
    <v-flex v-if="userSecurity[SecurityItemsKeys.ADMIN_MISSION].enable" xs6 sm4 md3 lg2 class="inline-block pa-4">
      <v-card style="text-align: center" class="pa-2" :to="{ name: 'NewAdminMission' }" exact>
        <v-img contain :src="require('@/assets/glider.jpg')" height="100"></v-img>
        <v-card-title>{{ $t('Admin.AdminMission.MenuTitle') }}</v-card-title>
      </v-card>
    </v-flex>
    <!-- <v-flex v-if="userSecurity[SecurityItemsKeys.ADMIN_FLEET].enable" xs6 sm4 md3 lg2 class="inline-block pa-4">
      <v-card style="text-align:center" class="pa-2" :to="{name:'NewAdminFleet'}" exact>        
        <v-img contain :src="require('@/assets/fleet.jpg')" height="100"></v-img>
        <v-card-title>{{$t('Admin.AdminFleet.MenuTitle')}}</v-card-title>      
      </v-card>      
    </v-flex>       -->
    <v-flex
      v-if="userSecurity[SecurityItemsKeys.ADMIN_POSITIONREMARQUABLE].enable"
      xs6
      sm4
      md3
      lg2
      class="inline-block pa-4"
    >
      <v-card style="text-align: center" class="pa-2" :to="{ name: 'NewPositionRemarquable' }" exact>
        <v-icon color="#444" size="100">mdi-map-marker</v-icon>
        <v-card-title>{{ $t('Admin.PositionRemarquable.MenuTitle') }}</v-card-title>
      </v-card>
    </v-flex>
    <v-flex v-if="userSecurity[SecurityItemsKeys.ADMIN_MAP_LAYER].enable" xs6 sm4 md3 lg2 class="inline-block pa-4">
      <v-card style="text-align: center" class="pa-2" :to="{ name: 'NewMapLayer' }" exact>
        <v-icon color="#444" size="100">mdi-map</v-icon>
        <v-card-title>{{ $t('Admin.MapLayer.MenuTitle') }}</v-card-title>
      </v-card>
    </v-flex>
    <v-flex
      v-if="userSecurity[SecurityItemsKeys.ADMIN_UPLOAD_MISSION].enable"
      xs6
      sm4
      md3
      lg2
      class="inline-block pa-4"
    >
      <v-card style="text-align: center" class="pa-2" :to="{ name: 'UploadFile' }" exact>
        <v-icon color="#444" size="100">mdi-file-upload</v-icon>
        <v-card-title>{{ $t('Admin.UploadFile.MenuTitle') }}</v-card-title>
      </v-card>
    </v-flex>
    <v-flex
      v-if="userSecurity[SecurityItemsKeys.ADMIN_COMMAND_COMPLETION].enable"
      xs6
      sm4
      md3
      lg2
      class="inline-block pa-4"
    >
      <v-card style="text-align: center" class="pa-2" :to="{ name: 'CmdCompletion' }" exact>
        <v-icon color="#444" size="100">mdi-arrow-decision-auto</v-icon>
        <v-card-title>{{ $t('Admin.CmdCompletion.MenuTitle') }}</v-card-title>
      </v-card>
    </v-flex>
    <v-flex v-if="userSecurity[SecurityItemsKeys.ADMIN_MESSAGE_LOGIN].enable" xs6 sm4 md3 lg2 class="inline-block pa-4">
      <v-card style="text-align: center" class="pa-2" :to="{ name: 'MsgAccueil' }" exact>
        <v-icon color="#444" size="100">mdi-message-alert</v-icon>
        <v-card-title>{{ $t('Admin.MsgAccueil.MenuTitle') }}</v-card-title>
      </v-card>
    </v-flex>
    <v-flex v-if="userSecurity[SecurityItemsKeys.ADMIN_NMEA_DISPLAY].enable" xs6 sm4 md3 lg2 class="inline-block pa-4">
      <v-card style="text-align: center" class="pa-2" :to="{ name: 'Nmea' }" exact>
        <v-icon color="#444" size="100">mdi-file-cog</v-icon>
        <v-card-title>{{ $t('Admin.Nmea.MenuTitle') }}</v-card-title>
      </v-card>
    </v-flex>
    <v-flex v-if="userSecurity[SecurityItemsKeys.ADMIN_HOME_IMAGE].enable" xs6 sm4 md3 lg2 class="inline-block pa-4">
      <v-card style="text-align: center" class="pa-2" :to="{ name: 'Image' }" exact>
        <v-icon color="#444" size="100">mdi-image-area</v-icon>
        <v-card-title>{{ $t('Admin.Image.MenuTitle') }}</v-card-title>
      </v-card>
    </v-flex>
    <v-flex v-if="userSecurity[SecurityItemsKeys.ADMIN_PWD_POLICY].enable" xs6 sm4 md3 lg2 class="inline-block pa-4">
      <v-card style="text-align: center" class="pa-2" :to="{ name: 'PwdPolicy' }" exact>
        <v-icon color="#444" size="100">mdi-lock</v-icon>
        <v-card-title>{{ $t('Admin.PwdPolicy.MenuTitle') }}</v-card-title>
      </v-card>
    </v-flex>
    <ais-query-tile />
  </v-layout>
</template>

<script>
import { SecurityItemsKeys } from '@/enum/SecurityItems'
import Vue from 'vue'
import Component from 'vue-class-component'
import AisQueryTile from '@/components/admin/AisQueryTile.vue'

@Component({
  name: 'HomeAdmin',
  components: { AisQueryTile },
})
export default class App extends Vue {
  get userSecurity() {
    return this.$store.myGetters.userSecurity
  }

  get SecurityItemsKeys() {
    return SecurityItemsKeys
  }
}
</script>
